export const getComparisonText = (i18n, comparisonDateRange) => {
  let comparisonDateRangeDateRangeText;
  let comparisonText;

  if (comparisonDateRange.rangeInDays <= 7) {
    comparisonText = i18n.getString(_TL_('last week'));
  } else {
    comparisonText = i18n.getString(_TL_('previous period'));
  }

  const formattedStart = i18n.formatDate(comparisonDateRange.start);
  const formattedEnd = i18n.formatDate(comparisonDateRange.end);

  if (formattedStart === formattedEnd) {
    comparisonDateRangeDateRangeText = `(${formattedStart})`;
  } else {
    comparisonDateRangeDateRangeText = `(${formattedStart} - ${formattedEnd})`;
  }

  if (comparisonDateRange.key === 'customPeriod') {
    comparisonText = '';
  }

  return `${i18n.getString(_TL_('Compared to '))}${comparisonText} ${comparisonDateRangeDateRangeText}`;
};
